// ============================================================================
// About gallery Swiper — 4-slide carousel; Fancybox bound globally in main.js
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $el = $('.js-about-gallery');
        if (!$el.length || typeof window.Swiper === 'undefined') return;

        new window.Swiper($el[0], {
            slidesPerView: 1.15,
            spaceBetween: 18,
            grabCursor: true,
            navigation: {
                prevEl: '.js-about-gallery-prev',
                nextEl: '.js-about-gallery-next',
                disabledClass: 'swiper-button-disabled',
            },
            breakpoints: {
                576: { slidesPerView: 1.4, spaceBetween: 18 },
                768: { slidesPerView: 2,   spaceBetween: 18 },
                992: { slidesPerView: 2.4, spaceBetween: 18 },
                1280: { slidesPerView: 3,  spaceBetween: 18 },
                1600: { slidesPerView: 3.2, spaceBetween: 18 },
            },
            a11y: {
                prevSlideMessage: 'Previous photo',
                nextSlideMessage: 'Next photo',
            },
        });
    });
})(jQuery);
